import { defineMessages } from 'react-intl';

const CROSS_PATH_STRINGS = defineMessages({
  RUNNER_IMAGE_ALT: {
    defaultMessage: 'Runner running in the distance'
  },
  JOIN_OUR_TEAM: {
    defaultMessage: 'Join our team'
  },
  GET_PRESS_DETAILS: {
    defaultMessage: 'Get press details'
  }
});

export default CROSS_PATH_STRINGS;
